import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { TranslateModule } from '@ngx-translate/core';

import { DropdownActionsEnum } from '@shared/consts';
import { removeRedundantMenuDividers } from '@shared/utils/menu.utils';
import { ActionSubItem, ActionType, TableRow } from '../common';

@Component({
  selector: 'cipo-table-row-actions',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatIconModule, MatMenuModule, TranslateModule, FlexLayoutModule],
  templateUrl: './table-row-actions.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TableRowActionsComponent {
  row = input.required<TableRow>();
  actions = input<ActionType[]>([]);
  hasLeftIcons = input(false);
  hasRightIcons = input(false);
  triggerTabIndex = input(0);

  readonly dropdownActions = DropdownActionsEnum;
  readonly visibleActions = computed(() =>
    removeRedundantMenuDividers(
      this.actions().filter(action => !action.condition || action.condition(this.row())),
      action => action.id === DropdownActionsEnum.DIVIDER,
    ),
  );

  actionSelected = output<number>();

  onActionClick(action: ActionType) {
    if (action.subItems?.length === 1) {
      action.subItems[0].onSelect(this.row());
    } else {
      this.actionSelected.emit(action.id);
    }
  }

  onSubActionClick(sub: ActionSubItem, row: TableRow) {
    if (sub.subItems?.length === 1) {
      sub.subItems[0].onSelect(row);
    } else {
      sub.onSelect(row);
    }
  }
}
